import tpv from '@synergycms_core/utils/tpv/base';
const baseUrl = process.env.URL_ENVIRONMENT;

export default class AMAZON extends tpv {

  /** @type {boolean|string} */
  hotelId = false;
  /** @type {boolean|string} */
  trackingId = false;
  /** @type {boolean|string} */
  pinCode = false;
  /** @type {boolean|string} */
  currencyCode = false;
  /** @type {boolean|string} */
  amazonPayMerchantID = false;
  /** @type {boolean|string} */
  amazonOrderRef = false;
  /** @type {boolean|function} */
  confirmBookingOnlyStore = false;
  /** @type {boolean|Map} */
  reservation = false;
  /** @type {boolean|function} */
  onSubmitPromiseResolve = false;
  /** @type {boolean|function} */
  onSubmitPromiseReject = false;
  /** @type {number} */
  nRetry = 1;
  /** @type {boolean|function} */
  incrementPaymentRetry = false;
  /** @type {boolean|function} */
  showErrorNotification = false;

  /**
   *
   * @param reservation {Map}
   * @param incrementPaymentRetry {function}
   * @param tpvPaymentStatus {string}
   * @param showErrorNotification {function}
   */
  constructor({reservation, incrementPaymentRetry, tpvPaymentStatus, showErrorNotification}) {
    super();
    this.nRetry = parseInt(reservation.getIn(['payment', 'n_retry'], false) || 1, 10);
    this.incrementPaymentRetry = incrementPaymentRetry;
    this.showErrorNotification = showErrorNotification;
    if (
      tpvPaymentStatus === 'AMAZON:ERROR' &&
      reservation.getIn(['payment', 'payform_code']) === 'amazon_pay'
    ) {
      this.nRetry++;
      this.showErrorNotification('ha ocurrido un error con el proceso de pago online, por favor, vuelva a intentarlo');
      this.incrementPaymentRetry(this.nRetry);
    }

  }

  initConfirmationFlow = (hotelId, reservation, currencyCode, amazonPayMerchantID, confirmBookingOnlyStore, resolve, reject) => {
    this.hotelId = hotelId;
    this.reservation = reservation;
    this.trackingId = reservation.get('tracking_id');
    this.pinCode = reservation.get('pin_code');
    this.currencyCode = currencyCode;
    this.amazonPayMerchantID = amazonPayMerchantID;
    this.amazonOrderRef = reservation.getIn(['payment', 'amazon_order_reference_id'], false);
    this.confirmBookingOnlyStore = confirmBookingOnlyStore;
    this.onSubmitPromiseResolve = resolve;
    this.onSubmitPromiseReject = reject;


    if(this.amazonOrderRef) {
      return window.OffAmazonPayments.initConfirmationFlow(
        this.amazonPayMerchantID,
        this.amazonOrderRef,
        (confirmationFlow) => {
          return this.placeOrder(confirmationFlow)
        });
    } else {
      this.showErrorNotification('ha ocurrido un error con el proceso de pago online, por favor, vuelva a intentarlo');
      this.onSubmitPromiseReject(Error('ha ocurrido un error con el proceso de pago online, por favor, vuelva a intentarlo'));
    }
  };

  placeOrder = (confirmationFlow) => {
    return this.confirmOrderReference()
      .then(data => {
        this.confirmBookingOnlyStore();
        return confirmationFlow.success();
    })
      .catch(error => {
        this.onSubmitPromiseReject(error);
        this.incrementPaymentRetry(this.nRetry);
        this.showErrorNotification('ha ocurrido un error con el proceso de pago online, por favor, vuelva a intentarlo');
        return confirmationFlow.error();
      });
  };

  /**
   *
   * @returns {Promise}
   */
  confirmOrderReference = () => {
    const url = baseUrl + '/api/hotels/' + this.hotelId + '/cms/confirm_amazon_order_reference/' + this.trackingId;
    const data = {
      tracking_id: this.trackingId,
      pin_code: this.pinCode,
      currency_code: this.currencyCode,
      amazon_order_reference_id: this.amazonOrderRef,
      url: window.location.href
    };
    const extraHeaders = [
      { Authorization: 'Basic ' + btoa(this.trackingId + ':' + this.pinCode) }
    ];
    return this.query(url, 'PATCH', data, extraHeaders, true, false);
  };
}
